import { render, staticRenderFns } from "./drawer_petCage.vue?vue&type=template&id=b32cf1ae&scoped=true&"
import script from "./drawer_petCage.vue?vue&type=script&lang=js&"
export * from "./drawer_petCage.vue?vue&type=script&lang=js&"
import style0 from "./drawer_petCage.vue?vue&type=style&index=0&id=b32cf1ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32cf1ae",
  null
  
)

export default component.exports